import { mapState } from 'vuex'
export default {
  data() {
    return {
      timer: null
    }
  },
  computed: {
    ...mapState(['org_id'])
  },
  methods: {
    // 发送短信
    sendMsg(area, phone) {
      console.log(phone, area)
      // 验证手机号格式
      const phoneReg = /^1\d{10}$/;
      if (!phoneReg.test(phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      var data = {
        area: area,
        phone: phone,
        org_id: this.org_id
      }
      this.$axios
        .post('/common/index/sendSms', data)
        .then(res => {
          if (res.data.code === 200) {
            this.phone_text = '60秒后重发'
            this.timer = setInterval(() => {
              let i = parseInt(this.phone_text)
              if (i === 1) {
                clearInterval(this.timer)
                this.phone_text = '获取验证码'
                return
              }
              this.phone_text = i - 1 + '秒后重发'
            }, 1000)
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            })
          }
        })
        .catch(res => {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        })
    },
    sendMsg2(area, phone) {
      // 验证手机号格式
      const phoneReg = /^1\d{10}$/;
      if (!phoneReg.test(phone)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      var data = {
        area: area,
        phone: phone,
        org_id: this.org_id
      }
      this.$axios
        .post('https://twin-live.shktclass.com/sms/studentLoginSendSms', data)
        .then(res => {
          if (res.data.code === 200) {
            this.phone_text = '60秒后重发'
            this.timer = setInterval(() => {
              let i = parseInt(this.phone_text)
              if (i === 1) {
                clearInterval(this.timer)
                this.phone_text = '获取验证码'
                return
              }
              this.phone_text = i - 1 + '秒后重发'
            }, 1000)
          } else {
            this.$message({
              message: res.data.message || '获取失败',
              type: 'error'
            })
          }
        })
        .catch(res => {
          this.$message({
            message: res.data.message,
            type: 'error'
          })
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
